/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { emailTemplatesIndex } from '../../axios/emailTemplatesIndex'
import type {
	EmailTemplatesIndexError,
	EmailTemplatesIndexQueryParams,
	EmailTemplatesIndexResponse,
} from '../../types/EmailTemplatesIndex'

export const emailTemplatesIndexQueryKey = (params?: EmailTemplatesIndexQueryParams) =>
	[{ url: '/email-templates' }, ...(params ? [params] : [])] as const

export type EmailTemplatesIndexQueryKey = ReturnType<typeof emailTemplatesIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/EmailTemplateController.php EmailTemplateController::index */
export function emailTemplatesIndexQueryOptions(params?: EmailTemplatesIndexQueryParams, config?: AxiosRequestConfig) {
	return queryOptions<
		EmailTemplatesIndexResponse,
		AxiosError<EmailTemplatesIndexError>,
		EmailTemplatesIndexResponse,
		EmailTemplatesIndexQueryKey
	>({
		queryKey: emailTemplatesIndexQueryKey(params),
		queryFn: ({ signal }) => emailTemplatesIndex(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/EmailTemplateController.php EmailTemplateController::index */
export function useEmailTemplatesIndex<TSelectData = EmailTemplatesIndexResponse>(
	params?: EmailTemplatesIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					EmailTemplatesIndexResponse,
					AxiosError<EmailTemplatesIndexError>,
					TSelectData,
					EmailTemplatesIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<EmailTemplatesIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...emailTemplatesIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/EmailTemplateController.php EmailTemplateController::index */
export function useEmailTemplatesIndexSuspense<TSelectData = EmailTemplatesIndexResponse>(
	params?: EmailTemplatesIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					EmailTemplatesIndexResponse,
					AxiosError<EmailTemplatesIndexError>,
					TSelectData,
					EmailTemplatesIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<EmailTemplatesIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...emailTemplatesIndexQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
